import useEntity from "../../hooks/useMembersGroup";
import MembersGroupDetail from "../../components/membersGroup/MembersGroupDetail/MembersGroupDetail";
import MembersGroupScoped from "../../components/membersGroup/MembersGroupDetail/MembersGroupScoped";
import MembersGroupTabs from "../../components/membersGroup/MembersGroupDetail/MembersGroupTabs";
import { useGetMembersGroupQuery } from "../../apis/MembersGroup.api";
import { PrimaryMembersGroup } from "../../types/models/MembersGroup";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const MembersGroupDetailPage = () => {

    useTitle(t`Details Members Group`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { membersGroupId: id } = useParams();

    const { data, refetch } = useGetMembersGroupQuery(PrimaryMembersGroup.fromPath(id))
    const { deleteMembersGroup } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteMembersGroup(data, '..')
    }, [data, deleteMembersGroup])

    if (id === 'scoped') {
        return (<MembersGroupScoped/>)
    }

    return (
        <Box data-testid="MembersGroup-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <MembersGroupDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" justifyContent="center" spacing={1} sx={ { marginTop: "2em" } }>
                    
                    { 
        session.hasPermission('', 'applications/auth/entities/MembersGroups/update/view') &&
                        <Button size="small" variant="outlined" data-testid="MembersGroup-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { 
        session.hasPermission('', 'applications/auth/entities/MembersGroups/delete/view') &&
                        <Button size="small" color="error" variant="outlined" data-testid="MembersGroup-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <MembersGroupTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default MembersGroupDetailPage;
